import { createTheme } from "@mui/material/styles";
import { plPL } from "@mui/material/locale";

export const theme = createTheme(
  {
    palette: { mode: "light", primary: { main: "#1f4e5f" }, secondary: { main: "#b06a3b" } },
    typography: {
      fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      fontSize: 13,
    },
    shape: { borderRadius: 6 },
    components: {
      // Kosztorysy mają setki wierszy — domyślne odstępy MUI zjadłyby ekran.
      MuiTableCell: { styleOverrides: { root: { padding: "4px 8px" } } },
      MuiButton: { defaultProps: { size: "small" } },
      MuiTextField: { defaultProps: { size: "small" } },
    },
  },
  plPL,
);
